export const rules = {
    plan_name: [
      { required: true, message: "请输入", trigger: "blur" },
    ],
    plan_count: [
      { required: true, message: "请输入", trigger: "change" },
    ],
    start_time: [
      { required: true, message: "请输入", trigger: "change" },
    ],
    end_time: [
      { required: true, message: "请输入", trigger: "change" },
    ],
  }


  export const profit_rules = {
    ratio: [
      { required: true, message: "请输入", trigger: "change" },
    ]
  }

  
  export const cash_rules = {
    type: [
      { required: true, message: "请输入", trigger: "change" },
    ],
    cash: [
      { required: true, message: "请输入", trigger: "change" },
    ]
  }


  export let addRule = {
    title: [
        { required: true, message: "请填写合作商名称", trigger: "change" },
    ],
    name: [
        { required: true, message: "请填写联系人", trigger: "change" },
    ],
    phone: [
        { required: true, message: "请填写联系人电话", trigger: "change" },
    ],
    type: [
        { required: true, message: "请选择类型", trigger: "change" },
    ],
    coop_way: [
      { required: true, message: "请选择合作方式", trigger: "change" },
  ],
    
    city: [
        { required: true, message: "请选择城市", trigger: "change" },
    ],
    login_name: [
        { required: true, message: "请填写登录账号", trigger: "change" },
    ],

}

export const install_rules = {
  name: [
    { required: true, message: "请输入", trigger: "change" },
  ]
}